export class DeleteUserFailure {
    static readonly type = '[User] DeleteUserFailure';

    constructor(public payload: string) {}
}
